import { Assets } from '@timeflies/static-assets';
import React from 'react';
import { getNextSound, useSoundContext, useSoundCurrentContext, useSoundCurrentDispatch } from '../view/sound-context';
export var useSound = function () {
    var soundContext = useSoundContext();
    var currentSound = useSoundCurrentContext();
    var dispatchCurrentSound = useSoundCurrentDispatch();
    var fnRef = React.useRef();
    fnRef.current = function (soundKey) {
        if (!soundContext) {
            return;
        }
        var _a = getNextSound(soundContext, currentSound, soundKey, Assets.sounds), nextIndex = _a.nextIndex, nextSound = _a.nextAudio;
        nextSound.play();
        dispatchCurrentSound({ currentKey: soundKey, index: nextIndex });
    };
    // avoid unecessary sound playing (causing infinite loop)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return React.useCallback(function (musicKey) { return fnRef.current(musicKey); }, [fnRef, soundContext]);
};
export var useWithSound = function (soundKey) {
    var playSound = useSound();
    return React.useCallback(function (fn) {
        if (typeof fn !== 'function') {
            return fn;
        }
        return (function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            playSound(soundKey);
            return fn.apply(void 0, args);
        });
    }, [soundKey, playSound]);
};
